import {Link} from "react-router-dom";
import {Logo} from "../../../assets/images";

const Footer = () => {
    return (
        <footer className="mt-auto bg-footer">
            <div className="d-flex flex-column flex-md-row py-3 mx-5 gap-2 gap-md-5 align-items-center align-items-md-start">
                <img
                    className="mb-3  mb-md-0"
                    src={Logo}
                    width={120}
                    height={38}
                    alt="Footerlogo"
                />
                <div className="px-5 text-center text-md-start mb-3 mb-md-0">
                    <p className="fs-16 text-light fw-semibold">
                        Athletes For Athletes Solutions Sdn Bhd
                    </p>
                    <p className="fs-16 text-light">202001020366 (1376686-D)</p>
                </div>
                <div className="px-5 text-center text-md-start">
                    <p className="fw-medium fs-20 text-light">Quick Link</p>
                    <Link className="text-decoration-none" to="/privacy-policy">
                        <p className="fs-16 text-light">Privacy Policy</p>
                    </Link>
                    <Link className="text-decoration-none" to="/terms-condition">
                        <p className="fs-16 text-light">Terms Of Use</p>
                    </Link>
                </div>
            </div>
            <p className="fs-16 text-center text-muted">
                Copyright &#169; {new Date()?.getFullYear()} Athletes For Athletes Solutions Sdn Bhd
                (202001020366)
            </p>
        </footer>
    );
};

export default Footer;
